import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, Expand, X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogClose } from "@/components/ui/dialog";

const PHOTOS = [
  { src: "/img/gal_lantai1.jpg", title: "Lantai 1", sub: "Sofa biru & krem, meja kayu, dan bar kopi yang hangat.", span: "md:col-span-2 md:row-span-2" },
  { src: "/img/gal_teras.jpg", title: "Teras", sub: "Angin sore dan pemandangan jalan yang teduh.", span: "md:row-span-2" },
  { src: "/img/gal_lantai2.jpg", title: "Lantai 2", sub: "Balkon terbuka untuk ngobrol dan kerja santai.", span: "md:col-span-2" },
  { src: "/img/gal_depan.jpg", title: "Tampak Depan", sub: "Parkir mobil & motor tersedia.", span: "" },
];

export const Gallery = () => {
  const [idx, setIdx] = useState(null);
  const open = idx === null ? null : PHOTOS[idx];
  const step = (d) => setIdx((i) => (i + d + PHOTOS.length) % PHOTOS.length);

  useEffect(() => {
    if (idx === null) return;
    const onKey = (e) => {
      if (e.key === "ArrowRight") step(1);
      if (e.key === "ArrowLeft") step(-1);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [idx]);

  const navBtn = "absolute top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white/90 text-ink grid place-items-center hover:bg-white shadow active:scale-90 transition-transform";

  return (
    <section id="suasana" className="wrap mt-20 sm:mt-28 scroll-mt-24" data-testid="gallery-section">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <span className="text-xs font-bold tracking-[0.15em] text-forest">SUASANA UPLINK</span>
          <h2 className="font-serif font-semibold text-3xl sm:text-4xl tracking-tight text-ink mt-2">Pilih sudut favoritmu.</h2>
        </div>
        <p className="text-sm text-muted2 max-w-sm">Dua lantai dan teras yang nyaman untuk ngopi, bertemu teman, atau bertukar ide.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 md:auto-rows-[220px] gap-4 mt-8">
        {PHOTOS.map((p, i) => (
          <button key={p.title} type="button" onClick={() => setIdx(i)} aria-label={`Perbesar foto ${p.title}`}
            className={`group relative overflow-hidden rounded-2xl border border-sage-200 h-64 md:h-auto text-left cursor-zoom-in ${p.span}`} data-testid={`gallery-item-${i}`}>
            <img src={p.src} alt={`Suasana ${p.title} UPLINK COFFEE`} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            <span className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/85 text-ink grid place-items-center opacity-90 group-hover:opacity-100 transition-opacity"><Expand className="w-4 h-4" /></span>
            <span className="absolute inset-x-0 bottom-0 p-5 bg-gradient-to-t from-ink/75 via-ink/30 to-transparent text-paper block">
              <span className="block font-serif font-semibold text-xl">{p.title}</span>
              <span className="block text-sm opacity-90">{p.sub}</span>
            </span>
          </button>
        ))}
      </div>
      <Dialog open={!!open} onOpenChange={(v) => !v && setIdx(null)}>
        <DialogContent className="max-w-5xl w-[95vw] p-0 bg-ink border-0 overflow-hidden [&>button]:hidden" data-testid="gallery-lightbox">
          <DialogTitle className="sr-only">{open?.title}</DialogTitle>
          <div className="relative">
            {open && <img src={open.src} alt={`Suasana ${open.title} UPLINK COFFEE`} className="w-full max-h-[80vh] object-contain bg-ink" data-testid="gallery-lightbox-image" />}
            <div className="absolute inset-0 pointer-events-none">
              <button type="button" onClick={() => step(-1)} className={`${navBtn} left-3 pointer-events-auto`} aria-label="Foto sebelumnya" data-testid="gallery-lightbox-prev"><ChevronLeft className="w-6 h-6" /></button>
              <button type="button" onClick={() => step(1)} className={`${navBtn} right-3 pointer-events-auto`} aria-label="Foto berikutnya" data-testid="gallery-lightbox-next"><ChevronRight className="w-6 h-6" /></button>
            </div>
          </div>
          <div className="flex items-center justify-between gap-4 px-5 py-4 text-paper">
            <div><div className="font-semibold" data-testid="gallery-lightbox-title">{open?.title}</div><div className="text-sm opacity-80">{open?.sub}</div></div>
            <div className="text-sm opacity-70" data-testid="gallery-lightbox-counter">{idx !== null && `${idx + 1} / ${PHOTOS.length}`}</div>
          </div>
          <div className="absolute top-3 right-3">
            <DialogClose className="w-10 h-10 rounded-full bg-white/90 text-ink grid place-items-center hover:bg-white shadow" data-testid="gallery-lightbox-close" aria-label="Tutup">
              <X className="w-5 h-5" />
            </DialogClose>
          </div>
        </DialogContent>
      </Dialog>
    </section>
  );
};
